export default __webpack_public_path__ + "static/media/apiaries2.2ace8cbd.jpg";